(function () {
    'use strict';

    angular.module("imApp").factory("poFinishService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 180,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
